/**
 * Build/version markers for verifying which bundle is actually running.
 *
 * APP_BUILD is injected at build time (see package.json "build" script) and
 * falls back to 'dev' locally. SW_CACHE_VERSION must match SW_BUILD in
 * public/service-worker.js — bump both together when forcing a PWA refresh.
 */
export const APP_BUILD = process.env.REACT_APP_BUILD || 'dev';
export const SW_CACHE_VERSION = 'v15';

export function logBuildVersion() {
  try {
    console.log(`[build] LockedIn app=${APP_BUILD} sw=${SW_CACHE_VERSION}`);
  } catch (_) {
    /* console may be unavailable */
  }
}
